import classNames from 'classnames'
import { ServiceSearchButtons } from 'feature/serviceCenters/components'
import { TService } from 'feature/serviceCenters/types'
import { ControlsType, MarkType } from 'feature/YandexMap/types'
import { YandexMap } from 'feature/YandexMap/YandexMap'
import { ReactNode, SyntheticEvent } from 'react'
import { Tab, Tabs } from 'ui'

import style from './ServiceCentersTabletMobile.module.scss'

type TServiceCentersTabletMobile = {
  tabValue: string
  setPageType: (value: 'services' | 'address') => void
  handleChange: (event: SyntheticEvent, newValue: 'map' | 'list') => void
  data: TService[]
  isLoading: boolean
  children: ReactNode
}
// страница сц на мобильных устройствах и планшетах
export function ServiceCentersTabletMobile({
  tabValue,
  handleChange,
  data,
  setPageType,
  isLoading,
  children,
}: TServiceCentersTabletMobile) {
  return (
    <>
      <Tabs
        className={classNames(style.serviceTabs, 'mt24')}
        onChange={handleChange}
        value={tabValue || 'map'}
      >
        <Tab label='Карта' value='map' />
        <Tab label='Список' value='list' />
      </Tabs>
      <div className={style.tabPanel}>
        {tabValue === 'map' && (
          <YandexMap
            className={style.map}
            isMapClickable={false}
            marks={[MarkType.geolocationMark, MarkType.serviceMarks]}
            controls={[
              ControlsType.ZoomControl,
              ControlsType.GeolocationControlUnit,
            ]}
          />
        )}
        {tabValue === 'list' && data && !isLoading && <>{children}</>}
      </div>

      <ServiceSearchButtons setPageType={setPageType} />
    </>
  )
}
